import TransHistorySponsor from './container'

export default TransHistorySponsor
